/* Classified Dark - product page behaviour.
 *
 * Everything lives here rather than inline in the section, because switching
 * Character / Style / Fit replaces the section markup via innerHTML and inline
 * <script> tags do not re-execute when inserted that way. Handlers are global
 * so the onclick attributes in the re-rendered markup keep working, and
 * initProductPage() is re-run after every swap.
 */
(function () {
  'use strict';

  var variants = [];
  var currentOptions = {};
  var colorOptionIndex = -1;
  var assignedIds = '|';   // every image id owned by some variant, as |1|2|3|
  var colorImages = {};    // colour name (lowercase) -> array of image ids
  var filterMode = 'none'; // 'none' | 'color' | 'variant'

  /* ---------------------------------------------------------------- helpers */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var sym = window.shopCurrency || '$';
    return sym + (cents / 100).toFixed(2);
  }

  function findVariant() {
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var key in currentOptions) {
        if (variants[i].options[parseInt(key, 10)] !== currentOptions[key]) { match = false; break; }
      }
      if (match) return variants[i];
    }
    return null;
  }

  /* ------------------------------------------------------------ gallery */

  // Narrow the gallery to the images belonging to what is selected.
  //
  // filterMode decides whether filtering happens at all:
  //   'none'    - nothing about the options changes the artwork (mugs differ
  //               only by size, packs and lunchboxes have one variant). Show
  //               every image.
  //   'color'   - hoodies, tees, caps. Keep images whose alt text names the
  //               colour, plus that colour's variant images.
  //   'variant' - phone cases, where each model has its own mockup. Keep only
  //               that model's image.
  //
  // There is deliberately no "unattached images are generic" rule: on these
  // products most images are unattached but still colour-specific, so treating
  // them as generic showed every colour at once.
  function filterImagesForVariant(variant) {
    var thumbs = $$('.gallery-thumb');
    if (!thumbs.length || !variant) return;

    if (filterMode === 'none') {
      thumbs.forEach(function (t) { t.style.display = ''; });
      if (variant.featured_image) highlightThumb(variant.featured_image.id);
      return;
    }

    var colorName = (colorOptionIndex >= 0 && variant.options) ? variant.options[colorOptionIndex] : null;
    var needle = (colorName || '').toLowerCase();

    // Image ids belonging to the current selection. For a colour that is every
    // image of that colour on the image-source product - which is the ADULT
    // product on Kids pages, so the ids come from the map rather than from this
    // product's own variants.
    var wanted = [];
    if (filterMode === 'color' && needle && colorImages[needle]) {
      wanted = colorImages[needle];
    } else if (variant.featured_image) {
      wanted = [String(variant.featured_image.id)];
    }

    // Alt text is only trustworthy if somebody actually filled it in.
    var hasAltData = thumbs.some(function (t) {
      return (t.getAttribute('data-alt') || '').trim() !== '';
    });

    var matched = [];
    thumbs.forEach(function (t) {
      var id = t.getAttribute('data-image-id');
      var alt = (t.getAttribute('data-alt') || '').toLowerCase();
      var byAlt = filterMode === 'color' && hasAltData && needle && alt.indexOf(needle) !== -1;
      var byWanted = wanted.indexOf(id) !== -1;
      if (byAlt || byWanted) matched.push(t);
    });

    if (!matched.length) {
      thumbs.forEach(function (t) { t.style.display = ''; });
      if (wanted.length) highlightThumb(wanted[0]);
      return;
    }

    var variantImageId = wanted.length ? wanted[0] : null;

    thumbs.forEach(function (t) {
      var keep = matched.indexOf(t) !== -1;
      t.style.display = keep ? '' : 'none';
      if (!keep) t.classList.remove('active');
    });

    // Lead with the colour's own variant image where we have it, so the big
    // image is the plain product shot rather than a random lifestyle photo.
    var lead = null;
    if (variantImageId) {
      lead = matched.filter(function (t) { return t.getAttribute('data-image-id') === variantImageId; })[0];
    }
    if (!lead) lead = matched[0];

    matched.forEach(function (t) { t.classList.remove('active'); });
    lead.classList.add('active');
    var main = $('#mainImage');
    if (main) main.src = lead.getAttribute('data-full');
  }

  function highlightThumb(imageId) {
    var main = $('#mainImage');
    $$('.gallery-thumb').forEach(function (t) {
      var isMatch = t.getAttribute('data-image-id') === String(imageId);
      t.classList.toggle('active', isMatch);
      if (isMatch && main) main.src = t.getAttribute('data-full');
    });
  }

  function showVariantImage(variant) {
    filterImagesForVariant(variant);
  }

  window.changeMainImage = function (btn) {
    var main = $('#mainImage');
    if (main) main.src = btn.getAttribute('data-full');
    $$('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  /* ------------------------------------------------------------ options */

  // State of one option value GIVEN the other options currently selected:
  //   'ok'      - a variant exists and is in stock
  //   'oos'     - a variant exists but is sold out
  //   'missing' - no such combination exists at all
  function valueState(optionIndex, value) {
    var exists = false;
    var avail = false;
    variants.forEach(function (v) {
      if (v.options[optionIndex] !== value) return;
      for (var k in currentOptions) {
        var ki = parseInt(k, 10);
        if (ki === optionIndex) continue;
        if (v.options[ki] !== currentOptions[k]) return;
      }
      exists = true;
      if (v.available) avail = true;
    });
    if (!exists) return 'missing';
    return avail ? 'ok' : 'oos';
  }

  // Closest variant that still has the value just clicked, preferring stock.
  function nearestVariantFor(optionIndex, value) {
    var exact = variants.filter(function (v) { return v.options[optionIndex] === value; });
    var inStock = exact.filter(function (v) { return v.available; });
    return inStock[0] || exact[0] || null;
  }

  // Repaint every option button from currentOptions.
  function syncButtons() {
    $$('.color-swatch, .size-btn').forEach(function (b) {
      var oi = parseInt(b.getAttribute('data-option-index'), 10);
      if (isNaN(oi)) return;
      var val = b.getAttribute('data-value');
      var isSel = currentOptions[oi] === val;
      b.classList.toggle('selected', isSel);

      var state = valueState(oi, val);
      b.classList.toggle('opt-unavailable', state !== 'ok');
      b.setAttribute('title',
        state === 'missing' ? val + ' – not available with the current selection'
        : state === 'oos' ? val + ' – sold out'
        : val);

      if (isSel) {
        var label = $('#selectedOption' + (oi + 1));
        if (label) label.textContent = val;
      }
    });
  }

  function applyVariant(v) {
    var addBtn = $('.add-to-cart-btn');
    if (!v) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      return;
    }
    var idField = $('#variantId');
    if (idField) idField.value = v.id;
    updatePrice(v);
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    showVariantImage(v);
  }

  window.selectOption = function (btn) {
    var optionIndex = parseInt(btn.getAttribute('data-option-index'), 10);
    var value = btn.getAttribute('data-value');
    currentOptions[optionIndex] = value;

    var matched = findVariant();
    if (!matched) {
      // The combination does not exist - e.g. the NPC Tee has Light Blue in S
      // and M only. Move the OTHER selectors to a combination that does exist
      // rather than leaving the hidden variant id pointing at the old choice,
      // which would add the wrong item to the cart.
      matched = nearestVariantFor(optionIndex, value);
      if (matched) {
        matched.options.forEach(function (val, i) { currentOptions[i] = val; });
      }
    }

    syncButtons();
    applyVariant(matched);
  };

  function updatePrice(v) {
    var pe = $('.price-current');
    var we = $('.price-was');
    var be = $('.product-discount-badge');
    if (pe) pe.textContent = formatMoney(v.price);
    // .price-was / .product-discount-badge only exist when discount badges are
    // switched on in theme settings, so guard rather than assume.
    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (we) { we.textContent = formatMoney(v.compare_at_price); we.style.display = ''; }
      if (be) { be.textContent = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% off'; be.style.display = ''; }
    } else {
      if (we) we.style.display = 'none';
      if (be) be.style.display = 'none';
    }
  }

  window.changeQty = function (delta) {
    var inp = $('#qtyInput');
    if (inp) inp.value = Math.max(1, Math.min(99, (parseInt(inp.value, 10) || 1) + delta));
  };

  window.toggleCollapsible = function (btn) {
    btn.classList.toggle('open');
    btn.nextElementSibling.classList.toggle('open');
  };

  window.nudgeCarousel = function (btn, dir) {
    var track = $('.option-carousel', btn.parentElement);
    if (track) track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.7), behavior: 'smooth' });
  };

  /* --------------------------------------------- character / style / fit */

  // Rendered section HTML, keyed by product URL. Promises rather than strings,
  // so a prefetch already in flight is reused instead of fired twice.
  var sectionCache = {};

  // Character / Style / Fit switch products WITHOUT a page load, so the
  // geo-redirect in the page head never runs for them. Apply the same mapping
  // here, or an EU shopper clicking "Kids" lands on the US product and gets
  // US shipping rates at checkout.
  function geoTarget(url) {
    var geo = window.CLASSIFIED_GEO;
    if (!geo || !url) return url;
    var m = url.match(/\/products\/([^?#\/]+)/);
    if (!m) return url;
    var handle = m[1];
    var mapped = geo.resolve(handle);
    if (mapped === handle) return url;
    return url.replace('/products/' + handle, '/products/' + mapped);
  }

  function sectionUrl(url) {
    var root = document.getElementById('productRoot');
    var sectionId = root ? root.getAttribute('data-section-id') : '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }

  function fetchSection(url) {
    if (!sectionCache[url]) {
      sectionCache[url] = fetch(sectionUrl(url))
        .then(function (r) {
          if (!r.ok) throw new Error('bad response');
          return r.text();
        })
        .catch(function (err) {
          delete sectionCache[url]; // let a later attempt retry
          throw err;
        });
    }
    return sectionCache[url];
  }

  // Warm both the markup and the hero image, so a click has nothing left to
  // wait for. Without this the image only starts downloading after the swap,
  // which is what made the gallery flash.
  function prefetchSection(url) {
    if (!url) return;
    url = geoTarget(url);
    fetchSection(url).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var img = doc.getElementById('mainImage');
      if (img && img.getAttribute('src')) {
        var pre = new Image();
        pre.src = img.getAttribute('src');
      }
    }).catch(function () {});
  }

  // Swaps to a sibling product in place using Shopify's Section Rendering API,
  // so the gallery, price, colours and sizes all update without a page load.
  // Falls back to a normal navigation on any failure.
  function swapProduct(url) {
    url = geoTarget(url);
    var root = document.getElementById('productRoot');
    if (!root) { window.location = url; return; }

    // Only dim if the swap is actually slow. A prefetched click resolves in a
    // few milliseconds, and dimming it made a fast swap look like a stutter.
    var dimTimer = setTimeout(function () { root.classList.add('is-swapping'); }, 120);

    // The replacement panel is a different height, which yanked the page around
    // on every Character click. Anchor on the root's position in the viewport
    // and correct the scroll by the difference afterwards.
    var prevTop = root.getBoundingClientRect().top;

    fetchSection(url)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('productRoot');
        if (!next) throw new Error('no root in response');
        clearTimeout(dimTimer);
        root.parentNode.replaceChild(next, root);
        history.pushState({ swapped: true }, '', url);
        initProductPage();
        var delta = next.getBoundingClientRect().top - prevTop;
        if (delta) window.scrollBy(0, delta);
      })
      .catch(function () {
        clearTimeout(dimTimer);
        window.location = url;
      });
  }

  // Delegated so it keeps working on the re-rendered markup.
  document.addEventListener('click', function (e) {
    var target = e.target.closest ? e.target.closest('[data-swap]') : null;
    if (!target) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // let new-tab through
    e.preventDefault();
    swapProduct(target.getAttribute('data-swap'));
  });

  // Hovering a character is a strong signal it is about to be clicked, and buys
  // roughly the length of the pointer travel as a head start.
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest ? e.target.closest('[data-swap]') : null;
    if (t) prefetchSection(t.getAttribute('data-swap'));
  });

  // Touch devices have no hover, so start on finger-down rather than on tap.
  document.addEventListener('touchstart', function (e) {
    var t = e.target.closest ? e.target.closest('[data-swap]') : null;
    if (t) prefetchSection(t.getAttribute('data-swap'));
  }, { passive: true });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.swapped) window.location.reload();
  });

  /* ------------------------------------------------------------ cart */

  window.addToCart = function () {
    var btn = $('#addToCartBtn');
    var vid = $('#variantId').value;
    var qty = parseInt($('#qtyInput').value, 10) || 1;
    btn.textContent = 'Adding...';
    btn.classList.add('adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        setTimeout(function () { btn.textContent = 'Add to cart'; btn.classList.remove('adding'); }, 1500);
        openCartDrawer();
      })
      .catch(function () { btn.textContent = 'Add to cart'; btn.classList.remove('adding'); });
  };

  window.openCartDrawer = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
      $('#cartDrawer').classList.add('open');
      $('#cartOverlay').classList.add('open');
      document.body.style.overflow = 'hidden';
      var c = $('.cart-count');
      if (c) c.textContent = cart.item_count;
    });
  };

  window.closeCartDrawer = function () {
    $('#cartDrawer').classList.remove('open');
    $('#cartOverlay').classList.remove('open');
    document.body.style.overflow = '';
  };

  function renderCartDrawer(cart) {
    var el = $('#cartDrawerItems');
    var ft = $('#cartDrawerFooter');
    var tt = $('#cartDrawerTotal');
    if (!cart.items.length) {
      el.innerHTML = '<div class="cart-drawer-empty">Your cart is empty</div>';
      ft.style.display = 'none';
      return;
    }
    var h = '';
    var cur = cart.currency || 'USD';
    cart.items.forEach(function (item, i) {
      h += '<div class="cart-drawer-item"><img src="' + item.image + '" alt=""><div class="cart-drawer-item-info">' +
        '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
        '<div class="cart-drawer-item-variant">' + item.variant_title + '</div>' +
        '<div class="cart-drawer-item-price">' + (item.price / 100).toFixed(2) + ' ' + cur + '</div>' +
        '<div class="cart-drawer-item-qty">Qty: ' + item.quantity + '</div>' +
        '<button class="cart-drawer-item-remove" onclick="removeCartItem(' + (i + 1) + ')">Remove</button></div></div>';
    });
    el.innerHTML = h;
    tt.textContent = (cart.total_price / 100).toFixed(2) + ' ' + cur;
    ft.style.display = 'block';
  }
  window.renderCartDrawer = renderCartDrawer;

  window.removeCartItem = function (line) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        var c = $('.cart-count');
        if (c) c.textContent = cart.item_count;
      });
  };

  /* ------------------------------------------------------------ init */

  function initProductPage() {
    var variantsEl = $('#productVariantsJson');
    if (!variantsEl) return;

    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { variants = []; }
    currentOptions = {};

    colorOptionIndex = -1;
    assignedIds = '|';
    colorImages = {};
    filterMode = 'none';
    var mapEl = $('#galleryMeta');
    if (mapEl) {
      try {
        var gm = JSON.parse(mapEl.textContent);
        colorOptionIndex = typeof gm.colorIndex === 'number' ? gm.colorIndex : -1;
        assignedIds = gm.assigned || '|';
        filterMode = gm.filterMode || 'none';
        // "white::|1|2|;;black::|3|"  ->  { white: ['1','2'], black: ['3'] }
        (gm.colorImages || '').split(';;').forEach(function (chunk) {
          if (!chunk) return;
          var bits = chunk.split('::');
          if (bits.length < 2) return;
          colorImages[bits[0]] = bits[1].split('|').filter(function (x) { return x !== ''; });
        });
      } catch (err) { /* leave defaults - gallery then shows everything */ }
    }

    // Seed from whichever option buttons are marked selected, falling back to
    // the first variant. Single-value options are not rendered at all, so they
    // have to come from the variant.
    var first = variants[0];
    if (first && first.options) {
      first.options.forEach(function (val, i) { currentOptions[i] = val; });
    }
    $$('.color-swatch.selected, .size-btn.selected').forEach(function (b) {
      currentOptions[parseInt(b.getAttribute('data-option-index'), 10)] = b.getAttribute('data-value');
    });

    // Preload full-size gallery images so switching is instant.
    $$('.gallery-thumb').forEach(function (thumb) {
      var pre = new Image();
      pre.src = thumb.getAttribute('data-full');
    });

    // Move any Printify size table out of Product Details and into
    // Dimensions & Care.
    var dc = $('#productDetailsContent');
    var dm = $('#dimensionsContent');
    if (dc && dm) {
      $$('table', dc).forEach(function (t) {
        dm.appendChild(t.cloneNode(true));
        t.remove();
      });
    }

    // If the page loaded on a combination that does not exist, correct it
    // before the shopper can add anything to the cart.
    var current = findVariant();
    if (!current) {
      current = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
      if (current) current.options.forEach(function (val, i) { currentOptions[i] = val; });
    }
    syncButtons();
    applyVariant(current);

    // Once the page is idle, quietly pull the other three characters (and the
    // Style / Fit siblings) so switching is instant even without a hover -
    // which is most of the time on mobile. Skipped on metered connections.
    if (!(navigator.connection && navigator.connection.saveData)) {
      var runWhenIdle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
      runWhenIdle(function () {
        $$('[data-swap]').slice(0, 6).forEach(function (a) {
          prefetchSection(a.getAttribute('data-swap'));
        });
      }, { timeout: 3000 });
    }

    // Add ?debug=1 to any product URL to reveal what the theme can actually
    // see. Saves needing view-source, which is awkward on a preview theme.
    if (location.search.indexOf('debug') !== -1) {
      var dbg = $('#classifiedIndexDebug');
      if (dbg) dbg.style.display = 'block';
    }

    // Bring the selected model into view in the iPhone carousel.
    var sel = $('.option-carousel .size-btn.selected');
    if (sel && sel.scrollIntoView) sel.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
  window.initProductPage = initProductPage;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
